(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('chart-export', {
                parent: 'entity',
                url: '/chart-export',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'ChartExports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart-export/chart-exports.html',
                        controller: 'ChartExportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
    }
})();
